// eslint-disable-next-line strict
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const BuisinessVars = {
  breakPoints: {
    xxxsBreakPoint: 280,
    xxsBreakPoint: 320,
    xsBreakPoint: 370,
    smBreakPoint: 550,
    mdBreakPoint: 768,
    lgBreakPoint: 1024
  }
};
exports["default"] = BuisinessVars;
module.exports = exports["default"];